import {PaymentDetails} from "@bounce/shared/consumer/declarations";
import {IResponseData} from "@bounce/shared/consumer/pages/payment";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = PaymentDetails & {
  payment_plan_id?: string;
  account_id: string;
  only_method_change?: boolean;
};

type Data = IResponseData;

export const addPaymentMethod = async (variables: Variables): Promise<Data> => {
  const {account_id, only_method_change, ...data} = variables;
  const queryParam = only_method_change ? `?only_method_change=${only_method_change}` : "";
  const result = await axiosConsumerAppInstance.post<Data, AxiosResponse<Data>>(
    `/payment_methods/${account_id}${queryParam}`,
    data
  );

  return result.data;
};

export const useAddPaymentMethod = (
  options?: BaseMutationOptions<Data, Variables>
): BaseUseMutationResult<Data, Variables> => {
  return useBaseMutation(addPaymentMethod, {
    ...options,
    prefixKeysToReset: (data, variables) => [
      ["payment-methods", variables.account_id],
      ["account", variables.account_id, "dashboard"],
    ],
  });
};
